import Redux from 'redux';
import * as Bixby from '$/core';
import {
  ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE,
  ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING,
  ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING,
  ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS,
  CloDealActionTypes,
  CloDealBixbyIdMappingState,
} from './types';

const initialState: CloDealBixbyIdMappingState = {
  isLoading: false,
  error: undefined,
  cloDealBixbyIdMappings: undefined,
};

const cloDealBixbyIdMappingReducer: Redux.Reducer<CloDealBixbyIdMappingState> = (state = initialState, action: CloDealActionTypes): CloDealBixbyIdMappingState => {
  switch (action.type) {
    case ALL_CLO_DEAL_BIXBYID_MAPPING_LOADING:
    case ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ALL_CLO_DEAL_BIXBYID_MAPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cloDealBixbyIdMappings: action.payload
      };
    case ALL_CLO_DEAL_BIXBYID_MAPPING_FAILURE:
    case ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
      };
    case ALL_CLO_DEAL_BIXBYID_MAPPING_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default cloDealBixbyIdMappingReducer;
